<template>
  <div v-if="isPDF" ref="viewer" class="w-full h-full lg:w-160 lg:h-256" />
  <video
    v-else-if="isVideo"
    :src="src"
    :title="name"
    :controls="controls"
    :preload="preload"
    :class="cn({ 'aspect-square object-cover': preview }, props.class)"
    @loadedmetadata="$emit('loaded')"
  />
  <img
    v-else
    :src="src"
    :alt="name"
    :class="cn({ 'aspect-square object-cover': preview }, props.class)"
    @load="$emit('loaded')"
  />
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { usePage } from "@inertiajs/vue3";
import WebViewer from "@pdftron/pdfjs-express-viewer";
import { cn } from "@/Utils/cn";

const viewer = ref(null);

const emit = defineEmits(["loaded"]);

const props = defineProps({
  src: { type: String, required: true },
  type: { type: String, required: false },
  name: { type: String, default: "" },
  controls: { type: Boolean, required: false },
  preload: { type: String, default: "none" },
  preview: { type: Boolean, required: false },
  class: { type: null, required: false },
});

const isPDF = computed(() => props.type?.includes("pdf"));
const isVideo = computed(() => props.type?.includes("video"));

const locale = usePage().props.locale;

onMounted(() => {
  if (!isPDF.value) {
    return;
  }

  WebViewer(
    {
      path: "/pdfjsexpress",
      initialDoc: props.src,
      licenseKey: process.env.MIX_PDFJS_LICENSE_KEY,
    },
    viewer.value
  ).then((instance) => {
    const { Core } = instance;

    instance.UI.setLanguage(locale);

    Core.documentViewer.addEventListener("documentLoaded", () => {
      emit("loaded");
    });

    const iframeDoc = instance.UI.iframeWindow.document;
    const header = iframeDoc.querySelector(".Header");
    header.style.backgroundColor = "#fff";

    instance.UI.disableElements(["languageButton", "themeChangeButton"]);
  });
});
</script>
